import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import {
  renderDateTextField2,
  renderMultiLineTextField,
  renderSelectField4,
  renderSelectField6,
  renderTextField,
} from '../../form-global-components/components-form-components-for-react-final-form';
import {
  CLIENT_EMPLOYED_AT_DISCHARGE,
  CLIENT_HOUSING_AT_DISCHARGE,
  CLIENT_BEHAVIORAL_HEALTH_PROGRAMS_DURING_PROGRAM_STAY,
  CLIENT_DISCHARGE_STATUS,
  CLIENT_BENEFIT_APPLICATION_INITIATED,
  NA_YES_NO,
  NO_YES,
} from '../../../actions/action-constants';
class FormFieldsClientsTabsTabDischargeTermination extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderDateTextField2}
                    id='referralprojectedreleasedate' 
                    name='referralprojectedreleasedate'
                    label='Projected Release Date'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id='clientdischargedate'
                      name='clientdischargedate'
                      label='Client Discharge Date'
                    />
                </Grid>
              </Grid>


    {

      (
        this.props.clientdischargedateSelected !== null
        && this.props.clientdischargedateSelected !== undefined
        && this.props.clientdischargedateSelected.trim() !== ''
        && this.props.clientdischargedateSelected !==  '0000-00-00'
        // && this.props.clientdischargedateSelected !==  'Invalid date'
      )

    ?
    <>



                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={CLIENT_EMPLOYED_AT_DISCHARGE}
                      id='clientemployedatdischarge' 
                      name='clientemployedatdischarge'
                      label='Client Employed At Discharge'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={CLIENT_HOUSING_AT_DISCHARGE}
                      id='clienthousingatdischarge' 
                      name='clienthousingatdischarge'
                      label='Client Housing At Discharge'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                    <Field
                      locked={this.props.locked}
                      component={renderTextField}
                      id='clientdischargezipcode'
                      name='clientdischargezipcode'
                      label='Client Discharge Zip Code'
                      emptyText='Unknown'
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={CLIENT_BEHAVIORAL_HEALTH_PROGRAMS_DURING_PROGRAM_STAY}
                    id='clientbehavioralhealthprogramsduringprogramstay' 
                    name='clientbehavioralhealthprogramsduringprogramstay'
                    label='Client Behavioral Health Programs During Program Stay'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                    <Field
                      locked={this.props.locked}
                      component={renderTextField}
                      id='clientearningshourlyrate'
                      name='clientearningshourlyrate'
                      label='Client Earnings Hourly Rate'
                      emptyText='0.00'
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                    <Field
                      locked={this.props.locked}
                      component={renderTextField}
                      id='clientgrosssavings'
                      name='clientgrosssavings'
                      label='Client Gross Savings'
                      emptyText='0.00'
                    />
                </Grid>
              </Grid>
 
              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={CLIENT_BENEFIT_APPLICATION_INITIATED}
                    id='clientbenefitapplicationinitiated'
                    name='clientbenefitapplicationinitiated'
                    label='(BHTs) Client Benefit Application Initiated (RRC : ACA Compliant ?)'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientbenefitsawarded'
                    name='clientbenefitsawarded'
                    label='(BHTs) Client Benefits Awarded (RRC : ACA Compliant ?)'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientspotlightcandidate'
                    name='clientspotlightcandidate'
                    label='Client Spotlight Candidate'
                    footerMessage=''
                  />
                </Grid>
              </Grid>









            { (this.props.programSelected === '1' )
            ?
            <>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NA_YES_NO}
                    id='clientrrctransfertohomeconfinement'
                    name='clientrrctransfertohomeconfinement'
                    label='(RRC) Transfer to Home Confinement?'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NA_YES_NO}
                    id='clientrrchomeconfinementatrelease'
                    name='clientrrchomeconfinementatrelease'
                    label='(RRC) Client Home Confinement at Release?'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='clientrrcoverallgrossearningsytd'
                    name='clientrrcoverallgrossearningsytd'
                    label='(RRC) Client Overall Gross Earnings YTD'
                    emptyText='0.00'
                  />
                </Grid>
              </Grid>

            </>
            : null }




            { (this.props.programSelected === '5' )
            ?
            <>


              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NA_YES_NO}
                    id='clientbhtssocialdeterminantsurvey' 
                    name='clientbhtssocialdeterminantsurvey'
                    label='(BHTs) Client Social Determinant Survey'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NA_YES_NO}
                    id='clientbhtspostdischargeopenrolled'
                    name='clientbhtspostdischargeopenrolled'
                    label='(BHTs) Client Post Discharge OP Enrolled'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

            </>
            : null }



              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={CLIENT_DISCHARGE_STATUS}
                    id='clientdischargestatus'
                    name='clientdischargestatus'
                    label='Client Discharge Status'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    required
                    locked={this.props.locked}
                    component={renderSelectField4}
                    id='clientdischargesubstatus'
                    name='clientdischargesubstatus'
                    label='Client Discharge Sub Status'
                    footerMessage=''
                  >
                    <option value='0' >N / A</option>

{/* Successful -  */}
                    {this.props._reduxForm.values.clientdischargestatus === '2' ? <option value='1' >(RRC) Client discharged at scheduled release or completion date</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '2' ? <option value='2' >(Community Programs) Full Compliance (completed all program plan objectives; or term of stay expired)</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '2' ? <option value='3' >(Community Programs) Client self-discharged (committed no major rules violation and had stable housing at discharge)</option> : '' } 

{/* UnSuccessful - */}
                    {this.props._reduxForm.values.clientdischargestatus === '3' ? <option value='4' >Misconduct (e.g. alcohol, drugs or violence)</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '3' ? <option value='5' >(RRC/PTS/BCC): Conduct, compliance or disciplinary issues</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '3' ? <option value='6' >(RRC/PTS/BCC): Departed without agreement of referral source, i.e. escaped, absconded</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '3' ? <option value='7' >(Community Programs) Major rules violation or (other programs) Client self-discharged without stable housing</option> : '' }

{/* Neutral - */}
                    {this.props._reduxForm.values.clientdischargestatus === '4' ? <option value='8' >Injury or illness requiring extended hospitalization</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '4' ? <option value='9' >Death</option> : '' }
                    {this.props._reduxForm.values.clientdischargestatus === '4' ? <option value='10' >Administrative e.g. outstanding warrants or procedural issues</option> : '' } 

                  </Field>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='clientdischargestatuscomments'
                    name='clientdischargestatuscomments'
                    label='Client Discharge Status Comments'
                    rows='6'
                    footerMessage=''
                  />
                </Grid>
              </Grid>




    </>
    : '' }



            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsClientsTabsTabDischargeTermination.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string,
  clientdischargedateSelected: PropTypes.string,
}
export default FormFieldsClientsTabsTabDischargeTermination;